<div class="backoffice-breadcrumb" [style.background-color]="catalogueService.getProperty('mainColor')" >
  <svg width="24" height="24" (click)="backToExhibitors()"  viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.7051 7.41L11.1251 12L15.7051 16.59L14.2951 18L8.29508 12L14.2951 6L15.7051 7.41Z" fill="#fff" />
  </svg>
  <span (click)="backToExhibitors()" >{{ 'COMMON.BACK_TO_EXHIBITORS' | translate }}</span>
</div>

<div class="row pd-t50 exhibitor-backoffice-sub-header" [style.background-color]="catalogueService.getProperty('mainColor')" [style.color]="catalogueService.getProperty('languageColor')">
  <div class="col-lg-10 title-container" >
    <h1>{{ exhibitor['name'] }}</h1>
  </div>
  <div class="col-lg-2" *ngIf="buttonTranslation">
     <button type="button" (click)="goTo(buttonLink)" class="btn btn-light float-end mr-sm-2 mb-2">{{ buttonTranslation | translate }}</button>
  </div>
  <div class="col-12">
    <ul class="nav">
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{ 'active': active === 'detail' }" routerLink="/{{ catalogueName }}/exhibitor-backoffice/exhibitors/{{exhibitorId}}/exhibitor-detail">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITORS.DETAIL' | translate }}</a>
      </li>
      <li class="nav-item" *ngIf="rolesService.hasRoles(['ECATALOGUE_EXHIBITOR_EDITION'])">
        <a class="nav-link" [ngClass]="{ 'active': active === 'detail-admin' }" routerLink="/{{ catalogueName }}/exhibitor-backoffice/exhibitors/{{exhibitorId}}/exhibitor-detail-admin">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITORS.DETAIL_ADMIN' | translate }}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{ 'active': active === 'products' }" routerLink="/{{ catalogueName }}/exhibitor-backoffice/exhibitors/{{exhibitorId}}/products">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITORS.PRODUCTS' | translate }}</a>
      </li>
    </ul>
  </div>
</div>
